import { render, staticRenderFns } from "./ListagemArquivos.vue?vue&type=template&id=eda59c48&scoped=true"
import script from "./ListagemArquivos.vue?vue&type=script&lang=js"
export * from "./ListagemArquivos.vue?vue&type=script&lang=js"
import style0 from "./ListagemArquivos.vue?vue&type=style&index=0&id=eda59c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda59c48",
  null
  
)

export default component.exports